import TagManager from 'react-gtm-module';

// Replace 'GTM-XXXXXXX' with your actual GTM ID
const GTM_ID = 'G-7M7XX97YMJ';

export const initializeGTM = () => {
  // Only initialize GTM in production
  if (window.location.hostname === 'console.qualifyme.ai') {
    const tagManagerArgs = {
      gtmId: GTM_ID,
      dataLayer: {
        // You can add default dataLayer variables here
        appName: 'Jobzy Admin',
        environment: process.env.NODE_ENV
      }
    };

    TagManager.initialize(tagManagerArgs);
  }
};

// Helper function to push events to dataLayer
export const pushToDataLayer = (data: object) => {
  TagManager.dataLayer({
    dataLayer: data
  });
}; 